import "./Teamnews.css";
import series from "../../teamImage/series.jpg";
import backArrow from "../../../../images/arrow.png";
import whiteArrow from "../../../../images/white-arrow.png";
import logo from "../../../../components/images/logo.png";
import { NavLink, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

const Teamnews = ({ dark, myteam, teamId, MyBaseUrl }) => {
  const team = myteam || null;

  const slug = team
    ? `${team.name?.toLowerCase().replace(/\s+/g, "-")}-${team.api_id || team.id}`
    : "";

  const [teamNews, setTeamNews] = useState([]);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch(`${MyBaseUrl}/team/${teamId}/news`);
        const data = await response.json();

        if (data?.status === "success") {
          const newsArray = data?.data?.data || [];
          setTeamNews(Array.isArray(newsArray) ? newsArray : []);
        } else {
          setTeamNews([]);
        }
      } catch (error) {
        console.error("Error fetching team news:", error);
        setTeamNews([]);
      }
    };

    if (team.api_id || team.id) fetchNews();
  }, [team.api_id || team.id]);

  const [isStickyTop, setIsStickyTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 600) {
        if (window.scrollY >= 98) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      } else {
        if (window.scrollY >= 300) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {team?.name
            ? `${team.name} News | Latest Updates & Stories`
            : "Team News | Goal Arena"}
        </title>

        <meta
          name="description"
          content={
            team?.name
              ? `Get the latest news, transfer updates, match reports, and exclusive stories about ${team.name}. Stay updated with all ${team?.country || "football"} coverage in one place.`
              : "Stay updated with the latest football team news, transfers, match insights, and breaking updates on Goal Arena."
          }
        />

        <meta
          name="keywords"
          content={
            team?.name
              ? `${team.name}, ${team.name} news, ${team.name} transfers, ${team.name} squad, football news, ${team?.country}, match updates`
              : "football news, team news, transfers, match updates, soccer news"
          }
        />

        <meta
          property="og:title"
          content={
            team?.name
              ? `${team.name} News & Updates`
              : "Team News | Goal Arena"
          }
        />

        <meta
          property="og:description"
          content={
            team?.name
              ? `Latest updates, match reports, and breaking news about ${team.name}.`
              : "Stay updated with football team news and match coverage."
          }
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:image"
          content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={team?.name ? `${team.name} News` : "Team News | Goal Arena"}
        />
        <meta
          name="twitter:description"
          content={
            team?.name
              ? `Latest news and updates about ${team.name}.`
              : "Football team news and updates."
          }
        />
        <meta name="twitter:image" content={team?.logo || series} />
      </Helmet>

      <div className="homer">
        <div className="teamnewsWrapper">
          {/* <NavLink
            to="/teams"
            style={{ textDecoration: "none" }}
            className="ppp">
            <strong
              style={{
                cursor: "pointer",
                backgroundColor: "transparent",
                border: dark ? "none" : "none",
                color: dark ? "white" : "black",
                padding: "5px 10px",
                borderRadius: "5px",
              }}>
              {dark ? (
                <img
                  src={whiteArrow}
                  alt=""
                  className="whitearrow"
                  style={{ transform: "rotate(180deg)", scale: "0.7" }}
                />
              ) : (
                <img src={backArrow} alt="" className="blackarrow" />
              )}
            </strong>
          </NavLink>

          <section
            className="section1"
            style={
              dark
                ? { backgroundColor: "#272727ff" }
                : { backgroundColor: "whitesmoke" }
            }>
            <div>
              <img src={team?.logo} alt={team?.name} />
              <h1 style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
                {team?.name}
              </h1>
            </div>

            <span>
              <strong style={dark ? { color: "#e2e1e1ff" } : {}}>
                Country: {team?.country || "N/A"}
              </strong>
              <strong style={dark ? { color: "#e2e1e1ff" } : {}}>
                Stadium: {team?.venue_name || "N/A"}
              </strong>
            </span>

            <nav
              style={
                dark
                  ? {
                      backgroundColor: "#333333ff",
                      color: "#fff",
                      width: isStickyTop ? "108%" : "100%",
                      marginLeft: isStickyTop ? "-4%" : "0",
                      transform: isStickyTop
                        ? "translateX(0%)"
                        : "translateX(0)",
                      borderRadius: isStickyTop ? "0px" : "",
                      transition: "all 0.3s",
                    }
                  : {
                      width: isStickyTop ? "108%" : "100%",
                      marginLeft: isStickyTop ? "-4%" : "0",
                      borderRadius: isStickyTop ? "0px" : "",
                      transition: "all 0.3s",
                    }
              }>
              <ul style={{ backgroundColor: "transparent" }}>
                <NavLink
                  to={`/teams/${slug}`}
                  style={{ textDecoration: "none" }}>
                  <li
                    style={
                      dark
                        ? { color: "#fafafaff", backgroundColor: "transparent" }
                        : { backgroundColor: "transparent" }
                    }
                    className="navlink">
                    Overview
                  </li>
                </NavLink>

                <NavLink
                  to={`/teams/${slug}/news`}
                  style={{ textDecoration: "none" }}>
                  <li
                    style={dark ? { color: "#fafafaff" } : {}}
                    className="myactive">
                    News
                  </li>
                </NavLink>

                <NavLink
                  to={`/teams/${slug}/standings`}
                  style={{ textDecoration: "none" }}>
                  <li
                    style={dark ? { color: "#fafafaff" } : {}}
                    className="navlink">
                    Standings
                  </li>
                </NavLink>

                <NavLink
                  to={`/teams/${slug}/matches`}
                  style={{ textDecoration: "none" }}>
                  <li
                    style={dark ? { color: "#fafafaff" } : {}}
                    className="navlink">
                    Matches
                  </li>
                </NavLink>

                <NavLink
                  to={`/teams/${slug}/squad`}
                  style={{ textDecoration: "none" }}>
                  <li
                    style={dark ? { color: "#fafafaff" } : {}}
                    className="navlink">
                    Squad
                  </li>
                </NavLink>
              </ul>
            </nav>
          </section> */}

          <h1
            className="title"
            style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
            Team News
          </h1>

          <section className="thirdsection">
            {teamNews.slice(0, 1).map((item, index) => (
              <NavLink to={`/${item?.slug}`} className="new">
                <div
                  key={item?.id || index}
                  style={
                    dark
                      ? {
                          backgroundColor: "#333333ff",
                          boxShadow: "1px 1px 30px 1px rgba(0, 0, 0, 0.39)",
                        }
                      : {}
                  }>
                  <nav>
                    <img
                      src={item?.image !== null ? item?.image : series}
                      alt={item?.title}
                    />
                  </nav>

                  <nav className="con">
                    <h2>{item?.title}</h2>
                    <h3>{item?.excerpt}</h3>

                    <div>
                      <span>
                        {/* <img src={timer} alt="" /> */}
                        <strong>55hrs</strong>
                      </span>

                      <span>
                        {/* <img src={message} alt="" /> */}
                        <strong>240</strong>
                      </span>
                    </div>
                  </nav>
                </div>
              </NavLink>
            ))}
          </section>

          <section className="fourthsection">
            {teamNews.slice(1, 10).map((item, index) => (
              <NavLink to={`/news/${item?.slug}`} className="new">
                <div
                  key={item?.id || index}
                  style={dark ? { backgroundColor: "#333333ff" } : {}}>
                  <nav>
                    <img
                      src={item?.image !== null ? item?.image : series}
                      alt={item?.title}
                    />
                  </nav>

                  <nav className="con">
                    <h3>{item?.categories?.[0]?.name}</h3>
                    <h2>{item?.title}</h2>

                    <div>
                      <span>
                        {/* <img src={timer} alt="" /> */}
                        <strong>55hrs</strong>
                      </span>

                      <span>
                        {/* <img src={message} alt="" /> */}
                        <strong>240</strong>
                      </span>
                    </div>
                  </nav>
                </div>
              </NavLink>
            ))}
          </section>
        </div>
      </div>
    </>
  );
};

export default Teamnews;
